import AdminNav from "../Homepage/Components/AdminNav";
import { LoginBackground } from "../../Constants/Backgrounds";

const VendorLoginRequired = () => {
    return (
        <div className="flex flex-col h-screen">
            <AdminNav />
            <div
                className="w-full h-full flex justify-center "
                style={{
                    backgroundImage: `url(${LoginBackground})`,
                    backgroundSize: 'cover',
                    position: 'relative'
                }}
            >
                <div className="absolute inset-0 bg-black opacity-5 z-0" />
                <div className="sm:mt-12 w-full xs:w-[32rem] h-[34rem]  bg-white flex flex-col z-40">
                    <div className="px-16 py-10">
                        <h2 className="mt-8 text-2xl font-semibold"> You are not logged in</h2>
                        <h3 className="text-lg"> This page requires you to be logged in to view</h3>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default VendorLoginRequired;